<template>
    <div class="lawyer_detial" v-loading="loading">
        <div class="detial_tops">
            <div class="bg_img">
                <img src="@/assets/img/index/legal/detial_bg.png" alt="">
            </div>
            <div class="detial_info">
                <div class="detial_info_box">
                    <div class="title_box">
                        <!-- <img src="@/assets/img/login/Frame.png" alt=""> -->
                         <img src="@/assets/img/index/legal/Frame.png" alt="">
                        <span class="span1">首页</span> > <span class="span2">
                            法律咨询 > 预约律师 > 详情
                        </span>
                    </div>
                    <div class="info_box">
                        <div class="name_vips">
                            <div class="names">{{ ls_detial.name }}律师</div>
                            <div class="vips">
                                <img src="@/assets/img/index/legal/vips.png" alt="">/专业会员
                            </div>
                        </div>
                        <div class="address" v-if="ls_detial.work_company">
                            <img src="@/assets/img/index/home/address.png" alt="">
                            {{ ls_detial.work_company }}
                        </div>
                        <div class="teges">
                            
                            {{ get_cause_title(ls_detial.causeIds||'') }}
                        </div>
                        <div class="introduce">
                          {{ ls_detial.serve }}
                        </div>
                        <div class="phones" v-if="ls_detial.show_mobile ">
                             <img src="../../../assets/img/index/legal/phones.png" alt="">
                             <!-- {{ ls_detial.mobile }} -->
                             {{ ls_detial.show_mobile }}
                        </div>
                        <div class="btns_flex">
                            <div class="btns1" @click="handle_xd">在线委托</div>
                            <div class="btns2" @click="handle_xd">预约律师</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detial_check">
                <div class="detial_check_box">
                    <div class="check_flex">
                        <div class="check_item" :class="{'check_item_ac':check_ac==item.state}" v-for="(item,index) in check_list" :key="index" @click="handle_check(item)">
                            <div class="texts">{{ item.title }}</div>
                            <div class="borders"></div>
                        </div>
                    </div>

                  
                   
                </div>
            </div>
        </div>
        <div class="detial_boms">
            <div class="detial_boms_box">
                <div class="" v-if="check_ac==1">
                    <lawsuit_serve ref="lawsuit_serve" :ls_detial="ls_detial"></lawsuit_serve>
                </div>
                <div class="" v-if="check_ac==2">
                    <lawsuit_info ref="lawsuit_info" :ls_detial="ls_detial"></lawsuit_info>
                </div>
                <div class="" v-if="check_ac==3">
                    <lawsuit_case ref="lawsuit_case"></lawsuit_case>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
import lawsuit_serve from '@/components/legal_advice/lawsuit_detial/lawsuit_serve.vue'
import lawsuit_info from '@/components/legal_advice/lawsuit_detial/lawsuit_info.vue'
import lawsuit_case from '@/components/legal_advice/lawsuit_detial/lawsuit_case.vue'



export default {
    components: {
        lawsuit_serve,
        lawsuit_info,
        lawsuit_case,
    },
    name: "homes",
    data() {
        return {
            loading:false,
            ls_detial:{},
            check_ac:1,
            check_list:[
                {
                    title:'律师服务',
                    state:1,
                },
                {
                    title:'律师信息',
                    state:2,
                },
                {
                    title:'律师案例',
                    state:3,
                }
            ],
            cause_list:[],
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_detial()
        this.get_cause_list()

    },
    methods: {
        handle_xd(){
            this.$router.push({
                path:'/lawyer_sever_list',
                query:{
                    lawyer_id:this.$route.query.id
                }
            })
        },
        get_cause_list(){
            this.$api("cause", {
                
				// type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('案由',res)
                if (res.code == 1) {
                    this.cause_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_cause_title(ids){
            let text=''
            let text_list=[]
            let id_list=ids.split(',')
            
            this.cause_list.forEach((e)=>{
                id_list.forEach((v)=>{
                    if(e.id==v){
                        text_list.push(e.title)
                    }
                })
            })
            text=text_list.join(',')
            return text
        },
        handle_check(item){
            this.check_ac=item.state
        },
        get_detial(){
            this.$api("lawyersInfo", {
               id:this.$route.query.id,
			}, "get").then((res) => {
                this.loading = false
                console.log('律师详情',res)
                if (res.code == 1) {
                    this.ls_detial=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
    },

}
</script>
<style scoped lang="less">
.lawyer_detial{
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    // padding:21px ;
    padding-bottom: 100px;
    .detial_tops{
        position: relative;

        .bg_img{
            width: 100%;
            height:550px;
            position: absolute;
            z-index: 1;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .detial_info{
            height:550px;
            position: relative;
            
            z-index: 2;
            .detial_info_box{
                width: 1440px;
                height:550px;
                margin: auto;
                // background-color: #FFFFFF;
                .title_box{
                    padding: 21px 0;
                    display: flex;
                    align-items: center;

                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;
                    img{
                        width: 14px;
                        height: 14px;
                    }
                    .span1{
                        cursor: pointer;
                        margin-right: 10px;
                    }
                    .span2{
                        cursor: pointer;
                        margin-left: 10px;
                    }
                    img{
                        margin-right: 10px;
                    }
                }
                .info_box{
                    width: 760px;
                    margin-left: 100px;
                    .name_vips{
                        display: flex;
                        align-items: end;
                        .names{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 40px;
                            color: #FFFFFF;
                        }
                        .vips{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 16px;
                            color: #FFFFFF;
                            margin-left: 20px;
                            img{
                                width: 20px;
                                height: 20px;
                            }
                        }
                    }
                    .address{
                        display: flex;
                        align-items: center;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 20px;
                        color: #FFFFFF;
                        padding-top: 21px;
                        img{
                            // width:18px;
                            height: 24px;
                            margin-right: 10px;
                        }
                    }
                    .teges{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        padding-top: 25px;
                    }
                    .introduce{
                        
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        padding-top: 38px;
                    }
                    .phones{
                        display: flex;
                        align-items: end;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 32px;
                        color: #FFFFFF;
                        padding-top: 46px;
                        img{
                            width: 26px;
                            height: 26px;
                            margin-bottom: 5px;
                        }
                    }
                    .btns_flex{
                        display: flex;
                        align-items: center;
                        padding-top: 28px;
                        .btns1{
                            width: 160px;
                            height: 44px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            line-height: 44px;
                            cursor: pointer;
                            text-align: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #FFFFFF;

                        }
                        .btns2{
                            width: 160px;
                            height: 44px;
                            background: rgba(255,255,255,0.2);
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #FFFFFF; 
                            margin-left: 24px;
                            cursor: pointer;
                            text-align: center;
                            line-height: 44px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #FFFFFF;

                        }
                    }
                }
            }
        }
        .detial_check{
            // width: 1920px;
            height: 64px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            .detial_check_box{
                width: 1440px;
                height: 64px;
                margin: auto;
                .check_flex{
                    display: flex;
                    align-items: center;
                    
                    .check_item{
                        height: 64px;
                        margin-right:100px ;
                        cursor: pointer;
                        .texts{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #666666;
                            line-height: 62px;
                        }
                        .borders{
                            width: 64px;
                            height: 3px;
                            background: #FFFFFF;
                            border-radius: 0px 0px 0px 0px;
                        }
                        &:hover{
                        .texts{
                            color: #377CFD;
                        } 
                        .borders{
                                background: #377CFD;
                            }
                        }
                    }
                    .check_item_ac{
                        .texts{
                            color: #377CFD;
                        } 
                        .borders{
                            background: #377CFD;
                        }
                    }
                }
              
            }
        }
    }
    .detial_boms{
        .detial_boms_box{
            width: 1440px;
            margin: auto;
        }
    }
    
}

</style>